module.exports = {
	"ha": "bc",
	"id": 5.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Health Authority, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -145,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.29256489221294,
						"dataLabels": {
							"enabled": true,
							"format": "2166"
						}
					},
					{
						"y": 86.09766827980643,
						"dataLabels": {
							"enabled": true,
							"format": "1957"
						}
					},
					{
						"y": 82.71007479102508,
						"dataLabels": {
							"enabled": true,
							"format": "1880"
						}
					},
					{
						"y": 76.46282446106467,
						"dataLabels": {
							"enabled": true,
							"format": "1738"
						}
					},
					{
						"y": 65.55213374395072,
						"dataLabels": {
							"enabled": true,
							"format": "1490"
						}
					},
					{
						"y": null
					},
					{
						"y": 95.94594594594594,
						"dataLabels": {
							"enabled": true,
							"format": "639"
						}
					},
					{
						"y": 81.38138138138137,
						"dataLabels": {
							"enabled": true,
							"format": "542"
						}
					},
					{
						"y": 78.37837837837837,
						"dataLabels": {
							"enabled": true,
							"format": "522"
						}
					},
					{
						"y": 71.47147147147147,
						"dataLabels": {
							"enabled": true,
							"format": "476"
						}
					},
					{
						"y": 53.153153153153156,
						"dataLabels": {
							"enabled": true,
							"format": "354"
						}
					},
					{
						"y": null
					},
					{
						"y": 91.18644067796609,
						"dataLabels": {
							"enabled": true,
							"format": "269"
						}
					},
					{
						"y": 78.64406779661017,
						"dataLabels": {
							"enabled": true,
							"format": "232"
						}
					},
					{
						"y": 75.9322033898305,
						"dataLabels": {
							"enabled": true,
							"format": "224"
						}
					},
					{
						"y": 63.05084745762712,
						"dataLabels": {
							"enabled": true,
							"format": "186"
						}
					},
					{
						"y": 38.64406779661017,
						"dataLabels": {
							"enabled": true,
							"format": "114"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.70284661069016,
						"dataLabels": {
							"enabled": true,
							"format": "4722"
						}
					},
					{
						"y": 85.31640385009216,
						"dataLabels": {
							"enabled": true,
							"format": "4166"
						}
					},
					{
						"y": 81.93733360638952,
						"dataLabels": {
							"enabled": true,
							"format": "4001"
						}
					},
					{
						"y": 76.26459143968872,
						"dataLabels": {
							"enabled": true,
							"format": "3724"
						}
					},
					{
						"y": 66.63936104853573,
						"dataLabels": {
							"enabled": true,
							"format": "3254"
						}
					},
					{
						"y": null
					},
					{
						"y": 95.08050089445437,
						"dataLabels": {
							"enabled": true,
							"format": "1063"
						}
					},
					{
						"y": 86.8515205724508,
						"dataLabels": {
							"enabled": true,
							"format": "971"
						}
					},
					{
						"y": 83.54203935599284,
						"dataLabels": {
							"enabled": true,
							"format": "934"
						}
					},
					{
						"y": 76.47584973166369,
						"dataLabels": {
							"enabled": true,
							"format": "855"
						}
					},
					{
						"y": 59.83899821109123,
						"dataLabels": {
							"enabled": true,
							"format": "669"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.707435107787061,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.649122807017541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9345937659683194,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.5531914893617,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.269275028768702,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.054054054054057,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.179968701095458,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.690036900369009,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.812260536398464,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.630252100840334,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -8.813559322033903,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.754646840148698,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.964285714285708,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.70967741935484,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.297153389309848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.774671749258792,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9606337013922244,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.923269182704328,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.620837808807739,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.919499105545622,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.65475070555033,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.810504634397527,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.458244111349034,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.75438596491228,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser Health<br>n=2273"
			},
			{
				"x": 9,
				"text": "Interior Health<br>n=666"
			},
			{
				"x": 15,
				"text": "Northern Health<br>n=295"
			},
			{
				"x": 21,
				"text": "Vancouver Coastal Health<br>n=4883"
			},
			{
				"x": 27,
				"text": "Vancouver Island Health<br>n=1118"
			}
		],
		"dataTable": {
			"Fraser Health": [
				2273,
				2166,
				1957,
				1880,
				1738,
				1490
			],
			"Interior Health": [
				666,
				639,
				542,
				522,
				476,
				354
			],
			"Northern Health": [
				295,
				269,
				232,
				224,
				186,
				114
			],
			"Vancouver Coastal Health": [
				4883,
				4722,
				4166,
				4001,
				3724,
				3254
			],
			"Vancouver Island Health": [
				1118,
				1063,
				971,
				934,
				855,
				669
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_7.json
// module id = 172
// module chunks = 0